module.exports = __webpack_public_path__ + "static/img/12.6b94e0b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/12.png
// module id = XzfO
// module chunks = 0